module.exports = __webpack_public_path__ + "img/13-3W0.0ff76ff.jpg";